import { isEqual } from 'lodash';
import React, { ChangeEvent, FC } from 'react';
import styled from 'styled-components';
import { Grey } from '../../styles/colours';
import { RegionCheckbox, SelectAllCheckbox } from './regions-checkbox';
import { IRegions } from './regions-menu';

const Divider = styled.div`
  border-top: 1px solid ${Grey};
  height: 1rem;
`;

const StyledSalesOrgMenu = styled.ul`
  display: flex;
  flex-direction: column;
  height: 24rem;
  overflow-y: scroll;
  padding: 0;
  margin: 0;
`;

export interface IProps {
  regions: IRegions;
  selected: string[];
  setSelectedRegions: (salesOrg: string[]) => void;
}

export const RegionsList: FC<IProps> = props => {
  const { regions, selected, setSelectedRegions } = props;

  const toggleRegion = (org: string) => (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const index = selected.indexOf(org);
    if (index !== -1) {
      const pre = selected.slice(0, index);
      const post = selected.slice(index + 1);
      setSelectedRegions([...pre, ...post]);
    } else {
      const {
        target: { name },
      } = event;
      setSelectedRegions([...selected, name]);
    }
  };

  const toggleAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    const toggle = e.target.checked;
    setSelectedRegions(toggle ? Object.keys(regions) : []);
  };

  const menuItems = Object.entries(regions).map(
    ([region, { salesOrgs = [], flag = () => null } = {}]) => {
      return (
        <RegionCheckbox
          flagComponent={flag}
          key={region}
          salesOrgs={salesOrgs}
          label={region}
          checked={selected.indexOf(region) !== -1}
          onChange={toggleRegion(region)}
        />
      );
    }
  );
  return (
    <>
      <Divider />

      <StyledSalesOrgMenu>
        <SelectAllCheckbox
          checked={isEqual(selected.sort(), Object.keys(regions).sort())}
          onChange={toggleAll}
        />
        {menuItems}
      </StyledSalesOrgMenu>
    </>
  );
};
